/**
 * @file Reducer.
 */

import { default as actionTypes } from './actionTypes';
import { shallowUpdateState } from '../utilities';

export const INITIAL_STATE = Object.freeze({
	tableState: {},
	rowData: [],
	errorMessage: undefined,
	loading: true,
	success: false,
});

export default function reducer(state = INITIAL_STATE, action) {
	const { type, payload } = action;

	switch (type) {
		case actionTypes.UPDATE_TABLE_STATE:
			return shallowUpdateState(state, payload);

		case actionTypes.START_LOAD_DATA_REQUEST:
			return shallowUpdateState(state, payload);

		case actionTypes.RECEIVE_SUCCESS_RESPONSE:
			return shallowUpdateState(state, payload);

		case actionTypes.RECEIVE_ERROR_RESPONSE:
			return shallowUpdateState(state, payload);

		case actionTypes.RESET:
			return shallowUpdateState(state, INITIAL_STATE);

		default:
			return state;
	}
}
